<template>
  <div style="max-width: 1100px" class="mx-auto w-full mb-6 sm:mb-9">
    <div class="relative">
      <section class="flex items-center ml-4 sm:ml-0 mb-10">
        <OIcon icon="newspaper" svg-class="w-5 h-5 sm:w-[30px] sm:h-[30px]" />
        <h2 class="font-semibold text-20 sm:text-24 text-black ml-2.5">{{ $t('game.recommended') }}</h2>
      </section>

      <ArticleSlider
        v-if="articles.length"
        class="sm:px-0 bg-white border border-[#E6E6E6] rounded-xl"
        :articles="articles"
        arrow-color="#8197af"
        :data-layer="{ name: `Oyun - Slider` }"
      >
        <SwiperSlide v-for="article in articles" :key="article._id" class="px-7 py-5 u-center">
          <SuggestedArticle :article="article" variant="tag" />
        </SwiperSlide>
      </ArticleSlider>
    </div>
  </div>
</template>
<script>
import { defineComponent, useContext, ref, onMounted } from '@nuxtjs/composition-api';
import SwiperSlide from '@/modules/sliders/core/SwiperSlide';
import ArticleSlider from '~/modules/sliders/components/common/ArticleSlider';
import CarouselArticle from '~/modules/card/templates/common/CarouselArticle';
import SuggestedArticle from '~/modules/oyun/components/SuggestedArticle.vue';
import { OIcon } from '~/modules/common/components/ui';
import { useAuth } from '~/modules/auth/state/useAuth';

export default defineComponent({
  components: {
    CarouselArticle,
    ArticleSlider,
    SuggestedArticle,
    SwiperSlide,
    OIcon,
  },
  setup() {
    const { user, isLoggedIn } = useAuth();
    const { $service, $error } = useContext();
    const articles = ref([]);
    onMounted(async () => {
      try {
        const OOetTi = JSON.parse(localStorage.getItem('o-oet-ti'))?.data;
        const userId = isLoggedIn.value ? user.value._id : OOetTi;
        const { data } = await $service.category.getRecommendedArticles({
          userId,
          categories: 'Gaming',
          scopeId: 3,
          placementId: 2,
        });
        articles.value = data;
      } catch (error) {
        $error(error);
      }
    });
    return { articles };
  },
});
</script>
